export default "__VITE_ASSET__CDxjXGzL__"